// extracted by mini-css-extract-plugin
export default {"section":"styles_section__N0oRu","dots_light":"styles_dots_light__kjhIw"};